// src/components/compartidos/Footer.js
import React from 'react';
import './Footer.css';
import logoWisby from '../../assets/logos/logo_2.png'; // Reutilizamos el logo

// Componente `Footer` que renderiza esta parte de la interfaz.
const Footer = ({ t = {} }) => {
  return (
    <footer className="footer-wisby">
      <img src={logoWisby} alt="Wisby background logo" className="footer-bg-logo" />
      <div className="footer-content">
        <div className="footer-logo-and-links">
          <div className="footer-logo-container">
            <img src={logoWisby} alt="Wisby Logo" className="footer-main-logo" />
          </div>
          <div className="footer-links-grid">
            <div className="footer-column">
              <h4>{t.consultancy}</h4>
              <ul>
                <li><a href="#soluciones">{t.createShares}</a></li>
                <li><a href="#soluciones">{t.contracts}</a></li>
                <li><a href="#soluciones">{t.trademark}</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>{t.consultancy}</h4>
              <ul>
               <li><a href="#asesorias">{t.legalHelp}</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>NOSOTROS</h4>
              <ul>
                <li><a href="#nosotros">{t.aboutWisby}</a></li>
                <li><a href="#nosotros">{t.partners}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;